// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lDmUv","links":"Footer_links__SiCLk","copyright":"Footer_copyright__WRUNl"};